import version from '../../package.json';
import { environment as intEnvironment } from './environment.int';
import { environment as stageEnvironment } from './environment.stage';

type LocalApiTarget = 'INT' | 'STAGE';

// Toggle local API routing target here.
const LOCAL_API_TARGET: LocalApiTarget = 'STAGE'; //<--- YOU CAN EASILY SWITCH LOCAL TO TOGGLE BETWEEN INT or STAGE by changing this value

const API_ENDPOINT_KEYS = [
  'billingPortalApiHost',
  'billingPortalConsumerApiHost',
  'aipHostPortMenu',
  'chaseCallBackUrl',
  'hostedChaseCallBackUrl',
  'aipHostPortAdmin',
  'aipHostPortBase',
  'aipHostPort1',
  'aipHostPort2',
] as const;

const apiEnvironmentByTarget = {
  INT: intEnvironment,
  STAGE: stageEnvironment,
} as const;

const selectedApiEnvironment = apiEnvironmentByTarget[LOCAL_API_TARGET];

const localApiEndpointOverrides = API_ENDPOINT_KEYS.reduce((overrides, key) => {
  return {
    ...overrides,
    [key]: selectedApiEnvironment[key],
  };
}, {} as Pick<typeof intEnvironment, typeof API_ENDPOINT_KEYS[number]>);

const localPort = version.scripts.start.split('--port=')[1];
const localUrl = `http://localhost:${localPort}`;

export const environment = {
  production: false,
  hmr: false,
  version: version.version + '-local',
  envName: 'local',
  environmentName: 'DEV',
  origins: ['http://localhost:5000'],
  appUrl: 'https://localhost:5000',
  AIP_AGENCY_ROLE: 'AIGI-ROLE-DIGAIP-AGENCY',
  AIP_ADMIN_ROLE: 'ADMIN',
  aipHostPort: 'http://aigi-drvjbss001:8080/',
  billingPortalApiHost: localApiEndpointOverrides.billingPortalApiHost,
  billingPortalConsumerApiHost: localApiEndpointOverrides.billingPortalConsumerApiHost,
  bopQuoteEndPoint: 'api/quote',
  paymentUsIframe: 'https://secure4.paymentus.com/xotp/pm/aidc?authToken=',
  paymentUsOrigin: 'https://secure4.paymentus.com',
  postMessagePmDetailsOrigin: {
    agent: 'http://localhost:5000/payer-info',
    consumer: 'http://localhost:5000/direct/payment',
  },
  chaseOrigin: {
    version2: {
      origin: 'https://www.chasepaymentechhostedpay-var.com',
      iframeOrigin: `https://www.chasepaymentechhostedpay-var.com`,
    },
    version3: {
      origin: 'https://chase-var.hostedpaymentservice.net',
      iframeOrigin: `${localUrl}/chaseIframe`,
    },
  },

  aipHostPortMenu: localApiEndpointOverrides.aipHostPortMenu,
  chaseCallBackUrl: localApiEndpointOverrides.chaseCallBackUrl,
  hostedChaseCallBackUrl: localApiEndpointOverrides.hostedChaseCallBackUrl,
  aipHostPortAdmin: localApiEndpointOverrides.aipHostPortAdmin,
  aipHostPortBase: localApiEndpointOverrides.aipHostPortBase,
  aipHostPort1: localApiEndpointOverrides.aipHostPort1,
  aipHostPort2: localApiEndpointOverrides.aipHostPort2,
  pgrRedirectUrl: 'aHR0cHM6Ly9xYS5idXNpbmVzc3F1b3RlLnByb2dyZXNzaXZlY29tbWVyY2lhbC5jb20vYXJjaGNvbmZpcm1hdGlvbg==', //default redirectUrl for Progressive.

  //ROLE
  internal: 'ARCH',
  external: 'AGENCY',
  admin: 'ADMIN',
  internalUser: 'Internal',
  externalUser: 'External',
  INTERNAL_EMAIL_DOMAIN: [
    'archinsurance.com',
    'archgroup.com',
    'archcapservices.com',
    'archgso.com',
    'corp.archcapservices.com',
  ],
  SKIP_PORTALS_INTERNAL_USER: ['AIGI-BasePortal'],
  AUTO_PORTALS_INTERNAL_USER: [{ 'AIGI-BasePortal': 'AIGI-ROLE-DIGAIP-ARCH-UNDERWRITER' }],
  LAUNCHDARKLY_CLIENTID: '635fd8a8f772dc0bdb58c32d',
};
